<template>
  <div />
</template>

<script>
import SearchType from '@/enums/SearchType';
import TrackSearches from '@/mixins/TrackSearches';

export default {
  name: 'VetsterSearchTracking',

  mixins: [TrackSearches],

  mounted() {
    this.trackSearchLoad(SearchType.City);
    this.$destroy();
  },
};
</script>
